import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { GolfCart } from '../../Icons'
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';

class TeeTimeTile extends PureComponent {
  static propTypes = {
    classes: PropTypes.object,
    teetime: PropTypes.object,
    onBook: PropTypes.func,
    time: PropTypes.string,
    golfersFormatted: PropTypes.string,
    holes: PropTypes.number,
    price: PropTypes.string,
    transportation: PropTypes.string,
    onSale: PropTypes.bool,
    originalPrice: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  render() {
    const { classes, onBook, time, golfersFormatted, holes, price, totalPrice, transportation, onSale, id, originalPrice, booking, transactionFeesPrice } = this.props;
    const tile =
      <Grid container className={classes.borderBottom}>
          <Grid item xs={8} sm={6}>
            <span className={classes.time}>{time}</span> <br />
            <span className={classes.detail}> Golfers: {golfersFormatted}</span>
            <span className={classes.detail}>Holes: {holes}</span>
          {  transportation === 'Cart Included' ? <GolfCart viewBox="0 0 32 32" className={classes.icons}  /> : null }
            {/* <img className={classes.icons} src={SunIcon} alt="Icon Sun" /> */}
          </Grid>
          <Grid item xs={4} sm={6} className={classes.buttonGrid}>
            <section className={classes.prices}>
              <span className={classes.strike}>
                {onSale ? originalPrice : undefined}
              </span>
              <span>
                <span className={`${classes.teePrice} ${onSale ? classes.hasDeal : ''}`}>{totalPrice}</span>{' '}
                <Hidden smDown>
                  <span className={`${classes.ea} ${onSale ? classes.hasDeal : ''}`}>/ea</span>
                </Hidden>
                <div>
                  {transactionFeesPrice ? 
                    <span className={classes.feesDetail}>{price} + {transactionFeesPrice} fee</span> 
                    : null}
                </div>
              </span>
            </section>
            <Hidden smDown>
              <Button className={classes.button} classes={{ root:  classes.buttonRoot }}  style={{width: booking ? 96.01 : null }}
                onClick={booking ? () => true : () => onBook(id)}>
                { booking ? <CircularProgress className={classes.progress} size={20}/> : 'Book Now' }
              </Button>
            </Hidden>
            <Hidden mdUp>
              <Button className={classes.buttonMobile} classes={{ root:  classes.buttonRoot }}  style={{width: booking ? 96.01 : null }}
               onClick={ booking ? () => true : () => onBook(id)}>
              { booking ? <CircularProgress className={classes.progress} size={20} /> : 'Book Now' }
              </Button>
            </Hidden>
          </Grid>
      </Grid>

    return (
      <div className={classes.root} > {tile} </div>
    )
  }
}

const styles = theme => ({
  root: {
    flexGrow: 1,
    fontFamily: theme.typography.fontFamily
  },
  buttonGrid: {
    'text-align': 'right'
  },
  time: {
    fontSize: '16px',
    fontWeight: 600
  },
  buttonRoot: {
    textTransform: 'inherit',
    borderRadius: '3px'
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    },
    color: theme.palette.common.white,
    fontWeight: 600,
    fontSize: '13px',
    marginLeft: '20px'
  },
  buttonMobile: {
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    },
    color: theme.palette.common.white,
    fontWeight: 600,
    fontSize: '13px',
    marginTop: '5px'
  },
  prices: {
    fontSize: '16px',
    display: 'inline-block'
  },
  progress: {
    color: '#fff'
  },
  ea: {
    fontSize: '13px',
    color: theme.grouponBlack
  },
  mobileEach: {
    display: 'none',
    position: 'absolute',
    right: '25px',
    marginTop: '2px',
    fontSize: '13px',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  teePrice: {
    color: theme.grouponBlack,
    marginLeft: '7px',
    fontWeight: 'bold'
  },
  hasDeal:{
    color: theme.palette.primary.light
  },
  strike: {
    textDecoration: 'line-through',
    color: theme.palette.secondary.light,
    fontWeight: 600
  },
  detail: {
    marginRight: '10px',
    fontSize: '13px',
    color: theme.palette.secondary.dark
  },
  feesDetail: {
    fontSize: '13px',
    color: theme.palette.secondary.dark
  },
  icons: {
    width: '15px',
    height: '15px',
    marginLeft: '10px',
    position: 'relative',
    top: '3px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '5px',
      position: 'relative',
    }
  },
  borderBottom: {
    borderBottom: '1px solid #E6E7E8',
    padding: '25px',
    [theme.breakpoints.down('sm')]: {
      cursor: 'pointer',
      padding: '10px 8px 10px 8px',
    }
  }
});

export default withStyles(styles)(TeeTimeTile);



// WEBPACK FOOTER //
// ./src/components/TeeSheet/TeeTimeTile/index.js